import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { getPercentChange, roundFloatNumber } from '@stockaid/utils';
import { BaseComponent } from 'src/app/core/infrastructure/classes/base-component';

@Component({
  selector: 'app-discount-tag',
  templateUrl: './discount-tag.component.html',
  styleUrls: ['./discount-tag.component.scss'],
})
export class DiscountTagComponent extends BaseComponent {
  @Input() originalText: string = 'Original Price';
  @Input() saleText: string = 'Sale Price';
  @Input() originalPrice: number;
  @Input() salePrice: number;
  @Input() displayCurrency!: { code: string; symbol: string };
  @Input() closestParentClass!: string;
  @Input() hardSavePercent?: number;

  @ViewChild('triggerBadge') triggerBadgeRef!: ElementRef;
  
  get savePercent(): number {
    return this.hardSavePercent ? this.hardSavePercent : roundFloatNumber(getPercentChange(this.originalPrice, this.salePrice));
  }

  get savePrice(): number {
    return roundFloatNumber(this.originalPrice - this.salePrice);
  }

  isHovered = false;
  placement: 'top' | 'bottom' = 'top';

  onMouseEnter() {
    this.checkPosition();
    this.isHovered = true;
  }

  onMouseLeave() {
    this.isHovered = false;
  }

  private checkPosition() {
    if (!this.triggerBadgeRef) return;

    // Get position of the SPECIFIC BADGE element
    const badgeEl = this.triggerBadgeRef.nativeElement;

    const rect = badgeEl.getBoundingClientRect();

    let spaceAbove = rect.top;

    const parentElement = this.closestParentClass ? badgeEl.closest(`.${this.closestParentClass}`) : null;
    
    if(parentElement){
      const parentRect = parentElement.getBoundingClientRect();
      spaceAbove = spaceAbove - parentRect.top;
    }
    // Safety threshold (height of popup + padding)
    const safeZone = 100; 
    
    // Check if the badge is too close to the top of the window
    if (spaceAbove < safeZone) {
      this.placement = 'bottom';
    } else {
      this.placement = 'top';
    }
  }
}
